<div class="grid justify-content-center">
  <div class="col-12 align-items-center justify-content-center">
    <div class="card">
      <h5 class="m-0">{{ settings.title }}</h5>
      <br />
      <p-progressBar
        *ngIf="listingData"
        mode="indeterminate"
        [style]="{ height: '6px' }"
      ></p-progressBar>
      <p-table
        #dt
        [value]="data"
        [columns]="selectedColumns"
        [rows]="10"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [responsive]="true"
        [resizableColumns]="true"
        [reorderableColumns]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        selectionMode="single"
        columnResizeMode="expand"
        styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm"
        rowGroupMode="rowspan"
        groupRowsBy="id"
        dataKey="id"
      >
        <ng-template pTemplate="caption">
          <div
            class="flex md:justify-content-between md:align-items-center mt-2"
          >
            <div
              *ngIf="showSearchHelpers"
              class="flex align-items-center justify-content-center"
            >
              <p-multiSelect
                [options]="settings.columns"
                [(ngModel)]="selectedColumns"
                optionLabel="header"
                selectedItemsLabel="{0} columnas seleccionadas"
                [style]="{ width: '100%' }"
                placeholder="Filtrar Columna"
                class="mt-0 mb-2 md:mt-0"
              ></p-multiSelect>
              <span class="block ml-3 mb-2 p-input-icon-left w-24rem">
                <i class="pi pi-search"></i>
                <input
                  style="width: 100%"
                  pInputText
                  type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="Buscar..."
                />
              </span>
            </div>
            <div class="flex align-items-center justify-content-center mb-2">
              <ng-container *ngIf="settings.exportData">
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-excel"
                  (click)="exportExcel()"
                  class="p-button-success mr-2"
                  pTooltip="XLS"
                  tooltipPosition="bottom"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-pdf"
                  (click)="exportPdf()"
                  class="p-button-warning mr-2"
                  pTooltip="PDF"
                  tooltipPosition="bottom"
                ></button>
              </ng-container>
              <ng-container *ngIf="actionsHead">
                <div *ngFor="let actionHead of actionsHead">
                  <button
                    pButton
                    pRipple
                    [icon]="actionHead.icon"
                    [class]="actionHead.class"
                    (click)="actionHeadRow(actionHead)"
                    [pTooltip]="actionHead.pTooltip"
                    tooltipPosition="left"
                  ></button>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th
              *ngFor="let col of selectedColumns"
              pSortableColumn="{{ col.field }}"
            >
              {{ col.header }}
              <p-sortIcon field="{{ col.field }}"></p-sortIcon>
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
          <tr *ngIf="settings.filterColumns">
            <th *ngFor="let col of selectedColumns">
              <input
                id="filterColumn"
                pInputText
                style="width: 75%; max-width: 75%"
                type="text"
                (input)="dt.filter(transformDateInput($event.target.value, col.header), col.field, 'contains')"
              />
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-data
          let-rowgroup="rowgroup"
          let-rowspan="rowspan"
          let-rowIndex="rowIndex"
        >
          <tr>
            <ng-container *ngFor="let col of selectedColumns; let i = index">
              <ng-container *ngIf="col.rowspan; else withoutRowSpan">
                <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                  <span class="font-bold">
                    {{ data[col.field] | uppercase }}
                  </span>
                </td>
              </ng-container>

              <ng-template #withoutRowSpan>
                <td>
                  <p *ngIf="col.tag !== 'status'">
                    {{ data[col.field] }}
                  </p>
                  <p-tag
                    *ngIf="col.tag === 'status'"
                    [style]="{ background: data['statusColor'] }"
                    [severity]="data['statusTag']"
                  >
                    {{ data[col.field] }}
                  </p-tag>
                </td>
              </ng-template>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
